import { cx } from '@emotion/css';
import { indicator } from './questionWithTextFeild.style';

export default function QuizIndicator({
  questionCount,
  questionnumber,
  className = '',
}) {
  return (
    <div className={`${className} ${cx(indicator)}`}>
      {Array.from(Array(questionCount)).map((_item, index) => (
        <div className={index === questionnumber - 1 ? 'active' : ''} key={index} />
      ))}
    </div>
  );
}
